module.exports = __webpack_public_path__ + "static/media/genuine-background-ZHTW.a72cd856.png";